import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
    input: {
      flex: 1,
      textAlign: "center",
      "& input": {
        textAlign: "center",
        [theme.breakpoints.up("md")]: {
          padding: theme.spacing(0.3, 0, 0.5),
        },
      },
    },
    iconButton: {
      padding: theme.spacing(1),
      borderRadius: 0,
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0.5),
      },
    },
  })
);

const ParticipantSelector: React.FC<ParticipantSelectorProps> = ({
  onChange,
  count,
  disable,
}) => {
  const classes = useStyles();
  const [counter, setCounter] = React.useState<number>(count || 1);

  useEffect(() => {
    if (typeof onChange === "function") {
      onChange(counter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter]);

  return (
    <Paper className={classes.root} variant="outlined">
      <IconButton
        onClick={() => setCounter((prev) => (prev > 1 ? prev - 1 : prev))}
        className={classes.iconButton}
        aria-label="decrement"
        disabled={disable}
      >
        <RemoveIcon />
      </IconButton>
      <span className={classes.input}>{counter}</span>
      <IconButton
        onClick={() => setCounter((prev) => prev + 1)}
        className={classes.iconButton}
        aria-label="increment"
        disabled={disable}
      >
        <AddIcon />
      </IconButton>
    </Paper>
  );
};

export default ParticipantSelector;
